import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';

export default function BackButton({ updateShowIframeState }) {
  return (
    <>
      <Button
        onClick={() => updateShowIframeState(false)}
        style={{ margin: '0px auto 0px 0px', background: '#7f59e5' }}
        variant="outlined"
        startIcon={<ArrowBack />}
        variant="contained"
      >
        Back
      </Button>
    </>
  );
}
